module.exports = __webpack_public_path__ + "img/rect-layer.82065603.svg";